import { ExternalLink, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo-horizontal.png";
import CookieSettingsButton from "@/components/CookieSettingsButton";
import { useLanguage } from "@/contexts/LanguageContext";
import { useTranslation } from "@/hooks/useTranslation";

const Footer = () => {
  const { getLocalizedPath } = useLanguage();
  const { t } = useTranslation();
  const footer = t("footer");

  return (
    <footer className="bg-secondary border-t border-border/50">
      <div className="container mx-auto px-4 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6 lg:gap-12">
          {/* Logo */}
          <Link to={getLocalizedPath("/")} className="shrink-0 group">
            <img 
              src={logo} 
              alt="pannelliespositori.it" 
              width={320}
              height={80}
              className="h-20 w-auto transition-transform duration-300 group-hover:scale-[1.02]" 
            />
          </Link>
          
          {/* Description and contacts */}
          <div className="flex flex-col gap-4 flex-1">
            <p className="text-sm text-muted-foreground leading-relaxed max-w-md">
              {footer.description}
            </p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
              <a 
                href="mailto:info@pannelliespositori.it" 
                className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>info@pannelliespositori.it</span>
              </a>
              <a 
                href="tel:+393895675717" 
                className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
              >
                <Phone className="w-4 h-4" />
                <span>+39 389 567 5717</span>
              </a>
              <span className="flex items-center gap-2 text-muted-foreground">
                <MapPin className="w-4 h-4" />
                <span>Via delle Viole 23, Cremona</span>
              </span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-border/50">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
            <p>
              © {new Date().getFullYear()} pannelliespositori.it — {footer.project}{" "}
              <a 
                href="https://www.regalpack.it/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium text-foreground hover:text-primary transition-colors inline-flex items-center gap-1"
              >
                Regalpack Srl
                <ExternalLink className="w-3 h-3" />
              </a>
            </p>
            <div className="flex flex-wrap items-center gap-4">
              <Link 
                to={getLocalizedPath("/privacy-policy")} 
                className="hover:text-foreground transition-colors"
              >
                {footer.privacy}
              </Link>
              <Link 
                to={getLocalizedPath("/cookie-policy")} 
                className="hover:text-foreground transition-colors"
              >
                {footer.cookie}
              </Link>
              <CookieSettingsButton />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
